import styled from 'styled-components'

export const Image = styled.img`
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -ms-user-select: none;
`
